import { makeStyles } from '@material-ui/styles';
import TalenyaWatermark from '../../../assets/image/water_mark_5.png';
import PaycorWatermark from '../../../assets/image/paycor_watermark.png';
import { colorSchemeNames } from '../../../constants/StyleConfig';

export default makeStyles((theme) => ({
    watermark: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: `url(${theme.colorSchemeName === colorSchemeNames.PAYCOR ? PaycorWatermark : TalenyaWatermark}) repeat-y top !important`,
        backgroundSize: 'contain !important',
        zIndex: 2,
        opacity: theme.colorSchemeName === colorSchemeNames.PAYCOR ? 0.3 : 1,
    },
}));
